import { EQuizMode } from '@constants';
import { useTranslation } from 'react-i18next';

import { Wrapper, TitleWrapper, StyledImage } from './PracticalCaseDescription.styles';

import { useQuizInfo } from '@/hooks';

const IMG_HEIGHT = 200;

export const PracticalCaseDescription = () => {
  const { t } = useTranslation('StudentQuizTranslations');
  const { studentQuiz } = useQuizInfo();

  return (
    <Wrapper $isActive={false}>
      <TitleWrapper>{t(EQuizMode.PRACTICAL_CASE)}</TitleWrapper>
      <div>{studentQuiz?.parentQuiz?.description}</div>
      {studentQuiz?.parentQuiz?.file && (
        <StyledImage
          src={studentQuiz?.parentQuiz?.file.url}
          alt={studentQuiz?.parentQuiz?.file.name}
          height={IMG_HEIGHT}
        />
      )}
    </Wrapper>
  );
};
